import { type InteractionType } from "@crowdcoursing/api/openapi";
import { CalendarMonth, Call, Email, QuestionMark, Videocam } from "@mui/icons-material";

export const INTERACTION_TYPES: {
  label: string;
  value: InteractionType;
  icon: JSX.Element;
  color: string;
}[] = [
  {
    color: "success.main",
    icon: <Call fontSize="small" />,
    label: "Call",
    value: 1, // Green for calls
  },
  {
    color: "primary.main",
    icon: <Email fontSize="small" />,
    label: "Email",
    value: 2, // Blue for emails
  },
  {
    color: "warning.main",
    icon: <CalendarMonth fontSize="small" />,
    label: "Meeting",
    value: 3, // Orange for meetings
  },
  {
    color: "info.main",
    icon: <Videocam fontSize="small" />,
    label: "Video Call",
    value: 4, // Light blue for video calls
  },
  {
    color: "text.secondary",
    icon: <QuestionMark fontSize="small" />,
    label: "Other",
    value: 99, // Gray for other
  },
];

export const getInteractionTypeInfo = (type: InteractionType = 99) => {
  return INTERACTION_TYPES.find((t) => t.value === type) ?? INTERACTION_TYPES[INTERACTION_TYPES.length - 1];
};
